// Make initAccordions available globally
window.initAccordions = initAccordions;

// Function to initialize accordions
function initAccordions() {
  // Look for individual accordion containers instead of accordion blocks
  const accordions = document.querySelectorAll(
    ".accordion-container details.ac"
  );
  if (!accordions.length) return;

  // Process each accordion
  accordions.forEach((accordion, index) => {
    // For already initialized accordions, just return
    if (accordion.hasAttribute("data-initialized")) {
      return;
    }

    const summary = accordion.querySelector("summary");
    const panel = accordion.querySelector(".ac-panel");

    if (!summary || !panel) return;

    // Set initial state - we're uncommenting this to let all accordions be closed by default
    // Initial state will be controlled by the CMS
    /*
    if (index === 0) {
      accordion.setAttribute("open", "");
      accordion.classList.add("is-expanded");
      panel.style.display = "block";
      panel.style.visibility = "visible";
    } else {
      accordion.removeAttribute("open");
      accordion.classList.remove("is-expanded");
      panel.style.display = "none";
      panel.style.visibility = "hidden";
    }
    */

    // Handle click/touch events
    function toggleAccordion(e) {
      e.preventDefault();
      e.stopPropagation();

      const isCurrentlyOpen = accordion.hasAttribute("open");

      if (isCurrentlyOpen) {
        // Just remove the is-expanded class, but keep the open attribute until animation is done
        accordion.classList.remove("is-expanded");

        // Emit event for GSAP to handle animation
        const accordionEvent = new CustomEvent("accordion:close", {
          detail: { accordion, panel },
        });
        document.dispatchEvent(accordionEvent);

        // Listen for animation completion event from GSAP
        const completeHandler = () => {
          // Now remove the open attribute after animation
          accordion.removeAttribute("open");
          document.removeEventListener(
            "accordionAnimationComplete",
            completeHandler
          );
        };
        document.addEventListener(
          "accordionAnimationComplete",
          completeHandler
        );
      } else {
        // Set open attribute and is-expanded class
        accordion.classList.add("is-expanded");
        accordion.setAttribute("open", "");
        panel.style.display = "block";
        panel.style.visibility = "visible";

        // Emit event for GSAP to handle animation
        const accordionEvent = new CustomEvent("accordion:open", {
          detail: { accordion, panel },
        });
        document.dispatchEvent(accordionEvent);
      }
    }

    // Remove any existing event listeners by cloning
    const newSummary = summary.cloneNode(true);
    summary.parentNode.replaceChild(newSummary, summary);

    // Add event listeners to the new summary
    newSummary.addEventListener("click", toggleAccordion);
    newSummary.addEventListener("touchend", toggleAccordion, {
      passive: false,
    });

    // Mark as initialized
    accordion.setAttribute("data-initialized", "true");
  });
}

// Cleanup existing accordion listeners
function cleanupAccordions() {
  const accordions = document.querySelectorAll(
    ".accordion-container details.ac"
  );
  accordions.forEach((accordion) => {
    accordion.removeAttribute("data-initialized");

    // Remove event listeners by cloning summary
    const summary = accordion.querySelector("summary");
    if (summary) {
      const newSummary = summary.cloneNode(true);
      summary.parentNode.replaceChild(newSummary, summary);
    }
  });
}

// Make safeInitAccordions globally available
window.safeInitAccordions = safeInitAccordions;

// Safely run initialization with error handling
function safeInitAccordions() {
  try {
    cleanupAccordions();
    initAccordions();
  } catch (error) {
    console.log("Error initializing accordions:", error);
  }
}

// For navigation events
function handleNavigation() {
  safeInitAccordions();
  setTimeout(safeInitAccordions, 300);
}

// Event listeners
document.addEventListener(
  "DOMContentLoaded",
  () => {
    setTimeout(safeInitAccordions, 100);
  },
  { once: true }
);

window.addEventListener("load", safeInitAccordions, { once: true });
window.addEventListener("popstate", handleNavigation);

// For WordPress
if (typeof wp !== "undefined" && wp.domReady) {
  wp.domReady(safeInitAccordions);
}
